<template>
  <div class="menu">
    <!-- <div class="name" @click="handleNav('/')">JoyMe</div> -->
    <!-- <div class="name" @click="handleNav('/')">JoyInMe</div> -->
    <div class="name" @click="handleNav('/')">In2Fun</div>
    <button class="mobile_menu" @click="displayMenu">
      <span class="icon_bar"></span>
      <span class="icon_bar"></span>
      <span class="icon_bar"></span>
    </button>
    <ul class="menu_item" :class="{show: showMenu}">
      <li @click="handleNav('/detail/about')">ABOUT US</li>
      <li @click="handleNav('/detail/contact')">CONTACT US</li>
    </ul>
  </div>
</template>

<script>
export default {
  data(){
    return {
      showMenu: false
    }
  },
  methods: {
    displayMenu(){
      this.showMenu = !this.showMenu;
    },
    handleNav(path) {
      this.showMenu = false;
      this.$router.replace({
        path: path
      })
    }
  }
}
</script>

<style lang="less" scoped>
.menu {
  text-align: center;
  background: #f6f6f6;
  height: 100%;
  .name {
    font-size: 0.32rem;
    padding: 0.3rem 0;
  }
  .mobile_menu {
    cursor: pointer;
    position: absolute;
    top: 6px;
    right: 15px;
    display: none;
    float: right;
    padding: 9px 10px;
    background-color: transparent;
    background-image: none;
    border: 1px solid transparent;
    border-radius: 4px;
    .icon_bar {
      display: block;
      width: 22px;
      height: 2px;
      border-radius: 1px;
      background-color: #000;
      margin-bottom: 4px;
    }
  }
  .menu_item {
    cursor: pointer;
    li {
      margin-bottom: 32%;
      list-style: none;
    }
  }
}
@media (max-width: 576px) {
  .menu {
    position: fixed;
    top: 0;
    width: 100%;
    height: .48rem;
    background: #f6f6f6;
    .name{
      position: absolute;
      left: .2rem;
      top: .05rem;
      padding: 0;
      font-size: .2rem;
    }
    .menu_item{
      display: none;
      &.show{
        display: block;
        padding-top: .48rem;
        li{
          margin-bottom: 10%;
        }
      }
    }
    .mobile_menu{
      display: block;
    }
  }
}
</style>